<form class="ds-modal__content flag-form" novalidate [formGroup]="form" (keydown.enter)="onFormEnter($event)">
    <ds-select
        id="categoryId"
        formControlName="category"
        label="Category*"
        placeholder="Select Category"
        [isSearchable]="true"
        [options]="categoryOptions"
    >
        <mat-error>Category is required</mat-error>
    </ds-select>

    <div class="flag-form__follow-up">
        <ds-datepicker formControlName="followUpDate" label="Follow up date (optional)" placeholder="MM/DD/YYYY"></ds-datepicker>

        <ds-input formControlName="followUpTime" label="Follow up time (optional)" placeholder="HH:mm" onlyTime>
            <ng-container *ngIf="!form.controls.followUpDate.value" ngProjectAs="mat-hint">
                <mat-hint>Set a date first.</mat-hint>
            </ng-container>
            <mat-error>
                <ng-container *ngIf="form.controls.followUpTime.errors?.['minlength']">Time should be in HH:mm format</ng-container>
            </mat-error>
        </ds-input>
    </div>

    <ds-textarea
        formControlName="reason"
        label="Reason & Resolution*"
        placeholder="Provide a reason for this flag and how it can be resolved."
        [maxlength]="isUpdateFlag ? null : reasonMaxLength"
        [minRows]="4"
    >
        <ng-container *ngIf="isUpdateFlag" ngProjectAs="mat-hint">
            <mat-hint>An edit changes only the follow up date and time.</mat-hint>
        </ng-container>
        <mat-error>Reason is required</mat-error>
    </ds-textarea>
</form>

<div class="ds-modal__footer">
    <ds-button label="Cancel" theme="secondary-gray" (buttonClick)="cancel.emit()"></ds-button>
    <ds-button [isLoading]="isSaving" [label]="isUpdateFlag ? 'Update Flag' : 'Create Flag'" (buttonClick)="save.emit()"></ds-button>
</div>
